const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/plans/$planId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { PlanVersionRow } from "@/types/api/plan";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/plans/$planId")({
  beforeLoad: args => requirePermission(Permissions.Plans.View, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});